import API from '@/api/hierarchy';

export default {
  getGroupHierarchy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      API.getGroupHierarchy(payload)
        .then((response) => {
          commit('setGroups', response.data);
          commit('setGroupsMap', response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  findAssignedAsHierarchy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);
      API.findAssignedAsHierarchy(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },

  getGroupUsers(_context, payload) {
    return new Promise((resolve, reject) => {
      API.getGroupUsers(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
